var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunrise2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    width: 18,
    viewBox: "0 0 576 512",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.3 2.3c3.1-3.1 8.2-3.1 11.3 0l88 88c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L296 27.3V216c0 4.4-3.6 8-8 8s-8-3.6-8-8V27.3l-74.3 74.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l88-88zM182.5 225.2c5-2.1 10.7-1.5 15.2 1.6L288 289.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6s8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6l-7.4 3.1 7.4-3.1c2.1 5 1.5 10.7-1.6 15.2L489.9 464H470.5L528 380.6 414.7 359.8c-3.3-.6-5.8-3.2-6.4-6.4L387.4 240l-94.9 65.4c-2.7 1.9-6.3 1.9-9.1 0L188.6 240 167.8 353.3c-.6 3.3-3.2 5.8-6.4 6.4L48 380.6 105.5 464H86.1L34.8 389.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9zM398.9 464H382.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H177.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96zM8 496H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise2);
export default __webpack_public_path__ + "static/media/sunrise2.a8e00ca47d9ef0dcaee57b6dc8091cdc.svg";
export { ForwardRef as ReactComponent };